import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { IconWrapper } from '@framework/ui/components/icon/IconWrapper.tsx';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { FaCircle, FaRegCircle } from 'react-icons/fa';
import styled from 'styled-components';

const StyledIcon = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colorPrimary};
`;

const IndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 40px;
  height: 40px;
`;

interface ReadIndicatorProps {
  read?: Date | null;
}

/**
 * Indicatore della lettura della notifica
 * Se è stata letta nel tooltips mostra la data di lettura
 */
export function ReadIndicator(props: ReadIndicatorProps) {
  const { read } = props;
  const { t } = useTranslation();
  const text = read
    ? t('notifiche.alt-image-notifica-letta', 'Notifica Letta')
    : t('notifiche.alt-image-notifica-da-leggere ', 'Notifica da leggere');
  const tooltip = read ? (
    <span>
      {t('notifiche.letta-il', 'Letta il')} <ISODate date={read} />
    </span>
  ) : (
    t('notifiche.da-leggere ', 'Da leggere')
  );

  return (
    <IndicatorWrapper>
      <Tooltip title={tooltip} placement="left">
        <StyledIcon>
          <span className="sr-only">{tooltip}</span>
          <IconWrapper
            icon={
              read ? (
                <FaRegCircle aria-hidden="true" />
              ) : (
                <FaCircle aria-hidden="true" />
              )
            }
          />
        </StyledIcon>
      </Tooltip>
    </IndicatorWrapper>
  );
}
